import React, { useState, useEffect } from 'react';

export function SelectReasonMaintenance({
  onValueChange,
  placeholder = 'Selecione um motivo',
  disabled = false,
  className = '',
}) {
  const [motivos, setMotivos] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMotivos = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          'https://radar.tlpservicos.com.br/api/manutencoes/motivos-manutencao'
        );
        if (!response.ok) {
          throw new Error('Erro ao carregar motivos de manutenção');
        }
        const data = await response.json();
        setMotivos(data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro desconhecido');
        console.error('Erro ao buscar motivos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMotivos();
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    const id = value ? parseInt(value) : null;
    setSelectedId(id);
    onValueChange?.(id);
  };

  if (loading) {
    return (
      <div
        className={`w-full h-10 bg-gray-100 animate-pulse rounded-md flex items-center px-3 ${className}`}
      >
        <span className="text-gray-500">Carregando...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={`w-full h-10 bg-red-50 border border-red-200 rounded-md flex items-center px-3 ${className}`}
      >
        <span className="text-red-600 text-sm">Erro: {error}</span>
      </div>
    );
  }

  return (
    <select
      value={selectedId || ''}
      onChange={handleChange}
      disabled={disabled}
      className={`
        w-full px-3 py-2 text-sm bg-white border border-gray-300 rounded-md shadow-sm text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
        hover:border-gray-400
        disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
        ${className}
      `}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {motivos.map((motivo) => (
        <option key={motivo.id} value={motivo.id}>
          {motivo.descricao}
        </option>
      ))}
    </select>
  );
}
